<template>
  <div>
    <Loader v-if="loading"></Loader>
    <P401 v-else-if="!granted"></P401>
    <slot v-else></slot>
  </div>
</template>

<script>
import Vue from "vue";
import Loader from "./Loader";
import P401 from "./P401";

export default {
  name: "AuthWrapper",
  components: {
    Loader,
    P401
  },
  data() {
    return {
      connected: false,
      loading: false,
      denied: false,
      unsub: null
    };
  },
  computed: {
    granted: function() {
      return (
        (this.connected && !this.denied) || !(this.connected || this.denied)
      );
    }
  },
  watch: {
    $route() {
      this.$store.commit("site/denied", false);
    }
  },
  mounted: function() {
    Vue.nextTick(() => {
      this.connected = this.$store.getters["site/isConnected"];
      this.loading = this.$store.getters["site/isConnecting"];
      this.denied = this.$store.getters["site/denied"];

      this.unsub = this.$store.subscribe(mutation => {
        switch (mutation.type) {
          case "site/connected":
            if (!this.loading) {
              this.connected = mutation.payload;
            }
            break;

          case "site/connecting":
            this.loading = mutation.payload;
            if (!this.loading) {
              // Don't wait for the other mutation, check the connection now
              this.$store.dispatch("site/checkConnection");
            }
            break;
          case "site/denied":
            this.denied = mutation.payload;
            break;
        }
      });
      // Force a mutation now through an action's dispatch
      this.$store.dispatch("site/checkConnection");
      //setTimeout(this.loadingTimeout, 8000);
    });
  },
  methods: {
    loadingTimeout() {
      this.loading = false;
    },
    // Just in case this is needed
    unsubscribe() {
      this.unsub();
    }
  }
};
</script>
